<template>
  <div class="index">
    
    <topNav></topNav>
    
    <div class="top" :style="{'background-image':'url(static/news_top_bg.png)','position':'relative','width':'100%','height':'600px','background-size':'auto 100%','background-position':'0px 0px'}" >
      <div class="about_us_nav" style="display:flex;text-align:center;height:35px;background:url(static/year_bg.png) no-repeat;background-size:100% 100%;color:#fff;font-weight:700;line-height:35px;" > 
        <div style="margin-left:30%;cursor:pointer" @click="goYear(1)"><img src="static/year_go_big.png"   style="width:20px;"   /></div>
        <div style="margin-left:6%;">{{currentYear}}</div>
        <div style="margin-left:5%;cursor:pointer"  @click="goYear(0)" ><img src="static/year_go_small.png"  style="width:20px;"  /></div>
       </div>
    </div>


         <!--<img src="static/china_real_estate_industry_green_supply_chain_action.png" style="position:absolute;left:25px;top:150px;width:50%;" />-->
    <div style="position:absolute;left:25px;top:150px;width:68%;text-align:left;" class="brief_1 Impact" >Green Supply Chain Action in China’s Real Estate Industry</div>

    <!--<img src="static/under_top_logo.png" style="position:absolute;left:25px;top:200px;width:150px;" />-->

    <div style="position:absolute;left:25px;top:260px;width:55%;text-align:left;" class="brief_1 Impact"  v-if="$store.state.language === 'cn'">中国房地产行业<br/>绿色供应链行动</div>



 
    <pageLocation :currentLocation="curPage"></pageLocation>
 
    <div class="aboutUs" style="width:100%;height:auto;margin:120px auto 0px auto;" >
      <!-- aboutUs start -->
      
     <div style="width:80%;margin:0 auto"><img src='static/news.png' style="width:130px;display:block;margin:0 auto;"></div>
     <div style="width:80%;margin:0 auto"  v-if="$store.state.language === 'cn'"><img src='static/news_infomation_ch_text.png' style="width:100px;display:block;margin:10px auto auto auto;"></div>
     
     <div style="width:80%;margin:20px auto;border-top:1px solid #628838">
         <!--新闻列表-->
         <ul class="newsItem" v-for="(newItem,index) in newsList" :key="index">
           <li style="float:left;"> 
             
             <img v-if="newItem.imgUrl" :src="newItem.imgUrl" class="facePic" />
             <img v-else src='static/bottom-logo.png' class="facePic" />
             
           
           </li>
           <li style="float:left;margin-top:10px;">
             <div style="text-align:center;font-weight:700;font-size:20px;color:#57802b;font-family:'SourceHanSansCN,Microsoft Yahei,微软雅黑,verdana'">{{newItem.createdat.substring(5,10)}}</div>
             <div style="text-align:center;">{{newItem.createdat.substring(0,4)}}</div>
             <div style="text-align:center;">{{newItem.authorName}}</div>
             </li>
              <li @click="showOrHideDetail(newItem.articleId,$event,newItem.channelId)" style="margin-top:10px;border:1px solid #8fa926;border-radius:15px;color:#8fa926;width:26px;height:26px;line-height:26px;font-size:26px;">+</li>
              <li style="text-align:left;margin-top:10px;margin-bottom:10px;">{{newItem.articleName}}</li>
              <div style="width:100%;height:2px;clear:both;"></div>
              <!-- <li class="detailContent" :id="newItem.articleId" style="width:95%;display:none;text-align:left;" v-html="newItem.content.replaceAll('/uploadfile','http://gsc.see.org.cn/uploadfile')"></li> -->
              <li class="detailContent" :id="newItem.id" style="width:95%;display:none;text-align:left;">
                <!--应该是附件-->
              </li>
              <li class="detailContent" :id="newItem.articleId" style="width:95%;display:none;text-align:left;" v-html="newItem.content"></li>
          
         </ul>
         
     </div>
 
 
 <!--aboutUs end-->
    </div>

 
  
    <!--底部组件-->
    <friendLinkAndFooter></friendLinkAndFooter>

 
 
  </div>
</template>


<script>
import { articleListByPage,articleDetail } from "@/api";
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import friendLinkAndFooter from '@/components/friendLinkAndFooter'
import topNav from '@/components/topNav'
import pageLocation from '@/components/pageLocation'
export default {
  name: 'news',
  components:{
   topNav,friendLinkAndFooter,pageLocation
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      showNav:false,
      pages:1,
      //传给子组件的当前页面位置
      curPage:'新闻动态',

      curArticleCode:'WZNR201610311925050031',
      catCode:'000002|000012',
      curArticleContent:{},
      currentYear:'2021',
      yearList:[
                 {'year':'2021'},
                 {'year':'2020'},
                 {'year':'2019'},
                 {'year':'2018'},
                 {'year':'2017'},
                 {'year':'2016'}
      ],
      newsList:[]
    }
  },
  methods :{


      goYear(n){
        if(n==1){
          this.currentYear++;
        }else{
          this.currentYear--;
        }
          this.articleListByPage(this.catCode,this.currentYear)
          
      setTimeout(() => {

     var o=document.querySelectorAll('.detailContent img');
 
      if(o){
        for(var i=0;i<o.length;i++){
          o[i].setAttribute("style","width:100%")
        }
      }
        
      }, 2000);
      },


    showOrHideDetail(articleCode,event,channelId){
      if(event.target.innerHTML=='+'){
        this.articleDetail(articleCode);
        document.getElementById(articleCode).setAttribute("style","display:block")
        document.getElementById(articleCode+''+channelId).setAttribute("style", "display:block;text-align:left;")
        event.target.innerHTML='-';

            setTimeout(() => {

              var o=document.querySelectorAll('.detailContent img');
          
                if(o){
                  for(var i=0;i<o.length;i++){
                    o[i].setAttribute("style","width:100%")
                  }
                }
              
            }, 2000);

        
      }else{
        document.getElementById(articleCode+''+channelId).setAttribute("style", "display:none")
        document.getElementById(articleCode).setAttribute("style","display:none")
        event.target.innerHTML='+';
      }

    },


    articleDetail(articleCode){
      const params = {
          articleId: articleCode,
          isEn: this.$store.state.language === 'en' ? 1 : 0
        }
        articleDetail(params).then((res) => {
          // console.log(res);
          this.curArticleContent = res.data
          // this.list = [res.data]
          // this.content = 
          let articleFileList = res.data.nodeVoList;
          if(articleFileList){
            var fileHtml="";
            for(var i=0;i<articleFileList.length;i++){
                 fileHtml+="附件"+(i+1)+"：<a href='http://gsc.see.org.cn/file/file/api/download?nodeId="+articleFileList[i].noteId+"' >"+articleFileList[i].nodeName+"</a><br/>"
            }
             document.getElementById(articleCode+''+res.data.channelId).innerHTML=fileHtml;
          }else{
          document.getElementById(articleCode+''+res.data.channelId).setAttribute("style", "display:none")
          document.getElementById(articleCode).setAttribute("style", "display:none")
          }
            setTimeout(() => {

              var o=document.querySelectorAll('.detailContent img');
          
                if(o){
                  for(var i=0;i<o.length;i++){
                    o[i].setAttribute("style","width:100%")
                  }
                }
              
            }, 2000);


        })

    },

   articleListByPage(catCode,year) {
        var that=this
            // console.log(this.dateY,' =====____');
            const params = {
              page: that.pages,
              catCode: encodeURIComponent(catCode),
              year:year,
              limit:99999,
              isEn: this.$store.state.language === 'en' ? 1 : 0
            };
            articleListByPage(params).then(res => {
              let _list = res.data.list;
              for(let k=0;k<_list.length;k++){
                _list[k].id = _list[k].articleId+''+ _list[k].channelId
              }
              this.newsList = _list;
              if(0 <_list.length){
                this.articleDetail(_list[0].articleId)
              }

            });
          }
  },
   mounted() {
     var that=this;

     this.articleListByPage(that.catCode,that.currentYear)

      //加载新闻
      //this.articleDetail('000000004');
 
      setTimeout(() => {

     var o=document.querySelectorAll('.detailContent img');
 
      if(o){
        for(var i=0;i<o.length;i++){
          o[i].setAttribute("style","width:100%")
        }
      }
        
      }, 1000);

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.brief_1{
    font-size: 20px;
    font-weight: 900;
    color: #fff;
}
.Impact {
    font-family: Impact,微软雅黑;
}

.about_us_nav{margin:0px;padding:0px;position:absolute;bottom:-20px;width:90%;left:5%;}
 
.show{display:block;}
.item{width:100%;height:50px;margin:0px;display:block;}
.itemActive{background:#89a128;color:#fff;}
.itemNoActive{background:#fff;color:#89a128;}
.hidden{display:none;}
.index{
  margin:0px;
  padding:0px;
  width: 100%;
  min-height: 960px;
}

.el-select .el-input__inner{text-align:center}

.el-input__inner{text-align:center;background-color:#92ab26 !important}

.top{position:relative;width:100%;height:600px;background-size:auto 100%;background-position:0px 0px}

.newsItem{border-bottom:1px solid #628838;overflow:hidden;margin-top:10px;}

.newsItem .facePic{width:150px;}


.navBox{width:150px;}
.navBox li{height:30px;}
.navBox li a{color:#fff;text-align:right;display:block;width:100%;text-decoration: none;}

 
 
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/news.vue